export default __webpack_public_path__ + "static/media/arrow_up.ff35e5f7.svg";